import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Icon } from "antd";
import moment from "moment";
import { getOrderReport } from "../../../redux/actions/orderCard";

import "moment/locale/ru";
moment.locale("ru");

const OrderReport = ({ id }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getOrderReport(id));
  }, []);

  const { orderReport, orderReportIsLoading, orderReportErrors } = useSelector(
    state => state.Executorship.Orders.orderCard
  );

  const tablePlaceholder = (
    <Icon type="loading" style={{ fontSize: 44 }} spin />
  );

  const columns = [
    {
      title: "Дата/Время",
      dataIndex: "date",
      render: date => <span>{moment(date).format("DD.MM.YYYY HH:mm")}</span>
    },
    {
      title: "Действие",
      dataIndex: "event",
      render: event => <span>{event}</span>
    },
    {
      title: "Автор",
      dataIndex: "user",
      render: (_, data) => (
        <span>
          {data.user}
          <br />
          {data.role}
        </span>
      )
    },
    {
      title: "Статус",
      dataIndex: "status",
      render: status => <span>{status || "–"}</span>
    },
    {
      title: "Описание изменений",
      dataIndex: "changes",
      render: changes => (
        <span>
          {changes.length > 0 &&
            changes.map((item, index) => {
              return item && item.length ? (
                <span key={index} className="block-item">
                  {item}
                </span>
              ) : (
                "–"
              );
            })}
        </span>
      )
    }
  ];

  return (
    <div className="basicForm">
      <div className="drawer-table">
        <div className="drawer-table__wrap">
          <Table
            pagination={false}
            dataSource={orderReport}
            rowKey="key"
            columns={columns}
            locale={{
              emptyText: orderReportIsLoading
                ? tablePlaceholder
                : orderReportErrors &&
                  orderReportErrors.data &&
                  orderReportErrors.data.message
                ? orderReportErrors.data.message
                : "нет данных по этому заказу"
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default OrderReport;
